import { Component, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-sem-acesso',
  imports: [],
  templateUrl: './sem-acesso.component.html',
  styleUrl: './sem-acesso.component.scss',
})
export class SemAcessoComponent {
  private authService = inject(AuthService);

  logout(): void {
    this.authService.logout();
  }
}
